import { render, staticRenderFns } from "./SysDept.vue?vue&type=template&id=27fbb898&scoped=true"
import script from "./SysDept.vue?vue&type=script&lang=js"
export * from "./SysDept.vue?vue&type=script&lang=js"
import style0 from "./SysDept.vue?vue&type=style&index=0&id=27fbb898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fbb898",
  null
  
)

export default component.exports